import { render, staticRenderFns } from "./QRCode.vue?vue&type=template&id=2dbcd0c4&"
import script from "./QRCode.vue?vue&type=script&lang=ts&"
export * from "./QRCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports